import React from 'react';
import ColumnFilterContent from './_ColumnFilterContent';

class ColumnFilter extends React.Component {
  constructor() {
    super();
    this.state = { isFilterMode: false };
    this.setFilterMode = this.setFilterMode.bind(this);
    this.filterTable = this.filterTable.bind(this);
  }

  // Set the filter mode:
  setFilterMode(isFilterMode) {
    const { filterData } = this.props;

    this.setState({ isFilterMode }, () => {
      if (!isFilterMode) {
        filterData(null);
      }
    });
  }

  // Call the function to filter the table:
  filterTable(filterResult, filteredColumnPath) {
    const { filterData } = this.props;
    this.setState({ filterResult }, () => filterData(filterResult, filteredColumnPath));
  }

  render() {
    const {
      props,
      state,
      setFilterMode,
      filterTable
    } = this;

    const { isFilterMode } = state;
    const contentProps = {
      ...props,
      isFilterMode,
      setFilterMode,
      filterTable
    };

    return (
      <div className='table-filter-wrap'>
        <ColumnFilterContent {...contentProps} />
      </div>
    );
  }
}

export default ColumnFilter;